// Job roles for careers page
export const JOB_CATEGORIES = [
  {
    category: 'Neuromorphic & Brain-Inspired Artificial Intelligence',
    roles: [
      'Neuromorphic AI Engineer',
      'Spiking Neural Network Engineer',
      'Brain-Inspired AI Systems Engineer',
      'Neural Architecture Engineer',
      'Cognitive Computing Engineer'
      
    ]
  },
  {
    category: 'Advanced & Hybrid Artificial Intelligence',
    roles: [
      'Hybrid AI Systems Engineer',
      'Neuro-Symbolic AI Engineer',
      'General Artificial Intelligence Engineer',
      
      'Advanced Machine Intelligence Engineer'
    ]
  },
  {
    category: 'Artificial Intelligence Research',
    roles: [
      'Neuromorphic AI Research Scientist',
      'Artificial Intelligence Research Engineer',
      'Cognitive Systems Research Scientist',
      'Artificial General Intelligence Researcher'
    ]
  },
  {
    category: 'AI Systems, Architecture & Optimization',
    roles: [
      'AI Systems Engineer',
      'Neural Model Optimization Engineer',
      'Scalable AI Architecture Engineer',
      'Intelligent Systems Infrastructure Engineer'
    ]
  },
  {
    category: 'Internships — Artificial Intelligence (Neuromorphic & Hybrid)',
    roles: [
      'Neuromorphic AI Intern',
      'Spiking Neural Networks Research Intern',
      'Artificial Intelligence Research Intern',
      'Hybrid AI Systems Intern',
      'Cognitive AI Research Intern'
    ]
  }
];


// Convert role name to URL-friendly slug
export const roleToSlug = (role) => {
  return role.toLowerCase().replace(/\//g, '-').replace(/\s+/g, '-');
};

// News items for home page
export const NEWS_ITEMS = [
 {
  id: 1,
  title: "Neufora’s Advanced Neural Network",
  slug: "neufora-advanced-neural-network",
  excerpt: "Neufora unveils a next-generation neural network architecture designed for high-efficiency learning, scalability, and real-world intelligence.",
  image: "/images/news/neuralnet.jpeg"
},
  {
    id: 2,
    title: 'Next-Generation Robotics Platform Announced',
    excerpt: 'Our latest robotics framework introduces unprecedented levels of autonomy and real-world interaction capabilities.',
    slug: 'next-gen-robotics-platform',
    image: '/images/news/robo.jpg'
  },
  {
    id: 3,
    title: 'SerumAI: The Future of Intelligent Systems',
    excerpt: 'Introducing SerumAI, our Smart Enhanced Reactive Universal Machine that redefines what artificial intelligence can achieve.',
    slug: 'serumai-intelligent-systems',
    image: '/images/news/m.jpeg '
  }
];